import { Component, DestroyRef, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Sidebar } from './shared/sidebar/sidebar';
import { ToolbarComponent } from './shared/toolbar/toolbar.component';
import { SidebarService } from './shared/sidebar/sidebar.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { filter } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-root',
  imports: [MatButtonModule, RouterOutlet, MatSidenavModule, Sidebar, ToolbarComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly destroyRef = inject(DestroyRef);
  protected readonly title = signal('vaggit-admin');
  isMobile = false;
  isSidebarOpen = true;

  constructor(
    private sidebarService: SidebarService,
    private breakpointObserver: BreakpointObserver,
    private router: Router,
  ) {
    this.breakpointObserver
      .observe([Breakpoints.Handset, '(max-width: 991px)'])
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((result) => {
        const nextIsMobile = result.matches;
        const wasMobile = this.isMobile;
        this.isMobile = nextIsMobile;

        if (nextIsMobile && !wasMobile) {
          this.sidebarService.setSidebarOpenState(false);
        }

        if (!nextIsMobile && wasMobile) {
          this.sidebarService.setSidebarOpenState(true);
        }
      });

    this.sidebarService.isOpen$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((isOpen) => {
        this.isSidebarOpen = isOpen;
      });

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        if (this.isMobile) {
          this.sidebarService.setSidebarOpenState(false);
        }
      });
  }

  get showShell(): boolean {
    return !this.router.url.startsWith('/login') && !this.router.url.startsWith('/register');
  }
}
